module.exports = __webpack_public_path__ + "/font/fontawesome-webfont_32400f.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.eot?v=4.5.0
 ** module id = 474
 ** module chunks = 0
 **/